import { useEffect } from "react";
import Lenis from "lenis";

export const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    const hash = decodeURIComponent(window.location.hash.slice(1));
    const jump = () => {
      const el = hash && document.getElementById(hash);
      if (el) { lenis.resize(); lenis.scrollTo(el, { offset: -70, immediate: true }); }
    };
    const timers = [150, 900, 2000].map((ms) => setTimeout(jump, ms));
    const stop = () => timers.forEach(clearTimeout);
    window.addEventListener("wheel", stop, { once: true, passive: true });
    window.addEventListener("touchstart", stop, { once: true, passive: true });
    return () => {
      stop();
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchstart", stop);
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.resize();
    window.__lenis.scrollTo(el, { offset: -70 });
  } else el.scrollIntoView({ behavior: "smooth" });
};

export const prefillInquiry = (detail) => {
  window.dispatchEvent(new CustomEvent("rbtun:prefill", { detail }));
  setTimeout(() => scrollToId(document.getElementById("kontakt-form") ? "kontakt-form" : "kontakt"), 60);
};
